module.exports = __webpack_public_path__ + "static/img/manufactur-industry-h5-3.32058d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/manufactur-industry-h5-3.png
// module id = k2mB
// module chunks = 34